import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Welcome from "./pages/welcome/welcome";
import {Provider} from "react-redux";
import store from './config/store';
import {setupConfig} from "./config/configloader";
import {
    BrowserRouter,
    createBrowserRouter,
    createRoutesFromElements,
    Route, Router,
    RouterProvider,
    Routes
} from "react-router-dom";
import Login from "./pages/login/login";
import Portal from "./pages/portal/portal";
import {Auth0Provider, useAuth0} from '@auth0/auth0-react';

const root = ReactDOM.createRoot(document.getElementById('root'));
setupConfig();



root.render(
    <Auth0Provider
        domain="dev-c0t-0huq.us.auth0.com"
        clientId="uEDaWM2XLxUoAfq225au4WTlsIawNsFQ"
        authorizationParams={{
            redirect_uri: window.location.origin
        }}
    >
        <Provider store={store}>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Welcome />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/portal" element={<Portal />} />
                </Routes>
            </BrowserRouter>
        </Provider>
    </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
